module.exports = __webpack_public_path__ + "components/about-header/static/header--large-9b401ec4c14b6ad0a64e1f204e921e56.jpg";